export default __webpack_public_path__ + "static/media/Drift-errorIcon.59cb71c5.svg";